import BookingParameters from '../../../types/BookingParameters';
import ComposeBookingStep from '../../../types/ComposeBookingStep';
import ComposeBookingStepsUrls from '../types/ComposeBookingStepsUrls';

import compileUrlForParameters from './compileUrlForParameters';

const compileStepUrl = (
    step: ComposeBookingStep,
    urls: ComposeBookingStepsUrls,
    parameters: BookingParameters
) => {
    switch (step) {
        case 'pickupDate':
        case 'expired':
            return compileUrlForParameters(urls.pickupDate, parameters);

        case 'passengers':
            return compileUrlForParameters(urls.passengers, parameters);

        case 'numberOfBoats':
            return compileUrlForParameters(urls.numberOfBoats, parameters);

        case 'boatModel':
            return compileUrlForParameters(urls.boatModel, {
                ...parameters,
                boatModelId: undefined,
                numberOfBoats: undefined,
                numberOfPassengers: undefined,
            });

        case 'dock':
            return compileUrlForParameters(urls.dock, {
                ...parameters,
                dockId: undefined,
                boatModelId: undefined,
                numberOfBoats: undefined,
                numberOfPassengers: undefined,
            });
    }

    return undefined;
};

export default compileStepUrl;
